export const blockIconsAudioandvideoReplay = (
	<span className='material-symbols-outlined'>replay</span>
);
